import { Button, CircularProgress, Grid, Link, TablePagination } from "@mui/material";
import { useContext } from "react";
import { usersContext } from "../UsersContext";

let Toolbar = () => {
    let service = useContext(usersContext);

    return (
        <Grid container>
            <Grid item>
                {service.recordCount > 0 &&
                    <Button
                        size="small"
                        component={Link}
                        color="secondary"
                        onClick={async () => await service.exportUsers()}
                        disabled={service.isExporting}
                    >
                        {service.isExporting && <><CircularProgress size={20} />&nbsp;</>}Export users
                    </Button>
                }
            </Grid>
            <Grid item xs />

            <Grid item>
                <TablePagination
                    component="div"
                    count={service.recordCount}
                    onPageChange={service.handleChangePage}
                    page={service.search.pageNr}
                    rowsPerPage={service.search.pageSize}
                    rowsPerPageOptions={[service.search.pageSize]}
                    labelDisplayedRows={(props) => {
                        return (
                            <>
                                Total users:&nbsp;{service.recordCount} &nbsp;&middot;&nbsp;
                                <span>Page&nbsp;{props.page + 1}&nbsp;of&nbsp;{Math.ceil(props.count / service.search.pageSize)}</span>
                            </>
                        )
                    }}
                />
            </Grid>
        </Grid>
    )
}

export default Toolbar;